import Link from 'next/link';
import styles from './index.module.less';

interface CardItem {
  title: string;
  desc: string;
  buttonText: string;
  svg: string;
  svgBackgroundColor: string;
  link: string;
}

interface SectionHowData {
  title: string;
  cards: CardItem[];
}

export default function SectionHow({ content }: { content: any }) {
  const { title, cards } = content.contentInfo['section-how'] as SectionHowData;
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.cardsWrapper}>
        {cards.map((card, index) => (
          <div className={styles.card} key={index}>
            <div className={styles.cardContent}>
              <div className={styles.iconWrapper} style={{ backgroundColor: `${card.svgBackgroundColor}1A` }}>
                <img src={card.svg} alt={card.title} className={styles.icon} />
              </div>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardDesc}>{card.desc}</p>
              <Link href={card.link || '#'} className={styles.button}>
                {card.buttonText}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
